import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { A2UIComponentDefinition } from '../../types/A2UIComponents.types.tsx';
import type { A2UIDividerProps } from '../../types/A2UIComponents.types.tsx';

const styles = cssMap({
	horizontal: {
		borderBlockEnd: `${token('border.width')} solid ${token('color.border')}`,
		width: '100%',
	},
	vertical: {
		borderInlineEnd: `${token('border.width')} solid ${token('color.border')}`,
		alignSelf: 'stretch',
	},
});

type Props = {
	definition: A2UIComponentDefinition;
};

export const A2UIDivider = ({ definition }: Props): React.JSX.Element => {
	const def = definition as A2UIDividerProps;
	const axis = def.axis ?? 'horizontal';

	return <Box xcss={cx(styles[axis])} role="separator" />;
};
